var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectedActivities.length)?_vm._l((_vm.selectedActivities),function(activity){return _c('router-link',{key:activity.id,class:_vm.$style.activity,attrs:{"to":("/meetings/" + (activity.id))}},[_c('CallInfo',{class:_vm.$style.callInfo,attrs:{"activity":activity,"info":[],"actions":[],"isLink":true}})],1)}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1d5e770","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/OngoingMeetings.vue
// module id = yvOs
// module chunks = 1